/**
 * Skincare collection: Repair / Hydrate / Protect client-side filter.
 * Grid items use `data-skincare-routines` (space-separated keys).
 */
(() => {
  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const root = document.getElementById('SkincareRoutineFilter');
  if (!root) return;
  const grid = document.getElementById('ProductGridContainer');
  if (!grid) return;

  const items = () => grid.querySelectorAll('.grid__item[data-skincare-routines]');
  const emptyEl = document.getElementById('SkincareRoutineFilterEmpty');

  function setActive(btn) {
    root.querySelectorAll('[data-routine-filter]').forEach((b) => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }

  function apply(filter) {
    const normalizedFilter = normalize(filter);
    let visible = 0;
    items().forEach((li) => {
      const raw = normalize(li.getAttribute('data-skincare-routines'));
      const tags = raw ? raw.split(/\s+/) : [];
      const show = normalizedFilter === 'all' || tags.indexOf(normalizedFilter) !== -1;
      li.classList.toggle('skincare-routine-filter--hidden', !show);
      if (show) visible += 1;
    });
    if (emptyEl) {
      emptyEl.hidden = normalizedFilter === 'all' || visible > 0;
    }
  }

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-routine-filter]');
    if (!btn || !root.contains(btn)) return;
    const filter = btn.getAttribute('data-routine-filter') || 'all';
    setActive(btn);
    apply(filter);
  });

  /* Facet AJAX replaces the grid; reset client filter so we do not hide the new server-filtered products */
  document.addEventListener('tatha:product-grid-updated', () => {
    const allBtn = root.querySelector('[data-routine-filter="all"]');
    if (allBtn) {
      setActive(allBtn);
      apply('all');
    }
  });
})();
